<template>
<v-container id="dashboard" fluid tag="section" v-if="ver">
    <v-row v-if="anio_recuperacion!='' && false">
        <v-col>
            <span style="font-size:15px;"><strong>Año de recuperación desde: {{anio_recuperacion}}</strong></span>
        </v-col>
    </v-row>
    <v-row>

        <!-- CUADRO 2 - RECUPERACION DIARIA -->
        <v-col cols="12" sm="6" :lg="expediente?3:4">
            <base-material-stats-card id="2" :key="'B'+pedimentosB+ remesasB" :selected="selected==2" color="green darken-4" subTextColor="green darken-4" icon="mdi-clock-outline" title="Pedimentos " :value="pedimentosB" subtitle="Remesas" :smallValue="remesasB" subColor="black--text" sub-icon="mdi-clock-outline" sub-text="Recuperación Diaria" :onClickBtnLink="selectItem" iconBtn1="mdi-calendar" :titleBtn1="'MES ' +mesB" :onClickBtn1="cambiarMesB" />
        </v-col>
        <v-dialog v-model="dialogB1" max-width="300px">
            <v-card>
                <v-card-text>
                    <h5>Recuperación Diaria</h5>
                    <h5 class="caption gray--text font-weight-light">Seleccione el Mes</h5>
                    <v-container grid-list-md text-xs-center>
                        <v-row no-gutters dense>
                            <v-col>
                                <v-menu offset-x ref="menuB" v-model="menuB" :close-on-content-click="false" transition="scale-transition" min-width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field clearable v-on="on" v-model="mesB" label="Mes" color="secondary" prepend-icon="event"></v-text-field>
                                    </template>

                                    <v-date-picker v-model="mesB" color="secondary" scrollable locale="es-mx" @input="menuB = false" type="month">
                                        <v-spacer />

                                        <v-btn color="secondary" x-small @click="menuB = false">
                                            Cancelar
                                        </v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-col>

                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>

                    <v-spacer></v-spacer>
                    <v-btn small @click="dialogB1 = false">Cancelar</v-btn>
                    <v-btn small :loading="loading" :disabled="loading" color="primary" @click="loader = 'loading'; loading=true; estadisticaConsultaB();">Consultar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- CUADRO 3 - REVISION -->
        <v-col cols="12" sm="6" :lg="expediente?3:4">
            <base-material-stats-card id="3" :key="'C'+ impoC+ expoC" :selected="selected==3" color="secondary" subTextColor="secondary" icon="mdi-file-search-outline" title="Pedimentos" :value="impoC" :smallValue="expoC" subtitle="Remesas" subColor="black--text" sub-icon="mdi-file-search-outline" sub-text="Importaciones Temporales" :onClickBtnLink="selectItem" iconBtn1="mdi-calendar" :titleBtn1="'MES ' +mesC" :onClickBtn1="cambiarMesC" />
        </v-col>
        <v-dialog v-model="dialogC1" max-width="300px">
            <v-card>
                <v-card-text>
                    <h5>Pedimentos en Revisión</h5>
                    <h5 class="caption gray--text font-weight-light">Seleccione el Mes</h5>
                    <v-container grid-list-md text-xs-center>
                        <v-row no-gutters dense>
                            <v-col>
                                <v-menu offset-x ref="menuC" v-model="menuC" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                    <template v-slot:activator="{ on }">
                                        <v-text-field clearable v-on="on" v-model="mesC" label="Mes" color="secondary" prepend-icon="event"></v-text-field>
                                    </template>

                                    <v-date-picker v-model="mesC" color="secondary" scrollable locale="es-mx" @input="menuC = false" type="month">
                                        <v-spacer />

                                        <v-btn @click="menuC = false">
                                            Cancelar
                                        </v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-col>

                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>

                    <v-spacer></v-spacer>
                    <v-btn small @click="dialogC1 = false">Cancelar</v-btn>
                    <v-btn small :loading="loading" :disabled="loading" color="primary" @click="loader = 'loading'; loading=true; estadisticaConsultaC();">Consultar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- CUADRO 4 - operaciones -->
        <v-col cols="12" sm="6" :lg="expediente?3:4">
            <base-material-stats-card id="4" :key="'D'+ impoD+ expoD" :selected="selected==4" color="blue" subTextColor="blue" icon="mdi-mail" title="Pedimentos" :value="impoD" :smallValue="expoD" sub-icon="mdi-alert-box" sub-icon-color="green" subtitle="Remesas" sub-text="Operaciones de Retorno" subColor="black--text" :onClickBtnLink="selectItem" iconBtn1="mdi-calendar" :titleBtn1="'AÑO ' +mesD" :onClickBtn1="cambiarMesD" />
        </v-col>
        <v-dialog v-model="dialogD1" max-width="300px">
            <v-card>
                <v-card-text>
                    <h5>Operaciones de Retorno</h5>
                    <h5 class="caption gray--text font-weight-light">Seleccione el Mes</h5>
                    <v-container grid-list-md text-xs-center>
                        <v-row no-gutters dense>
                            <v-col>
                                <v-menu offset-x ref="menuD" v-model="menuD" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                    <template v-slot:activator="{ on }">
                                        <v-text-field clearable v-on="on" v-model="mesD" label="Mes" color="secondary" prepend-icon="event"></v-text-field>
                                    </template>

                                    <v-date-picker v-model="mesD" color="secondary" scrollable locale="es-mx" @input="menuD = false" type="month">
                                        <v-spacer />

                                        <v-btn @click="menuD = false">
                                            Cancelar
                                        </v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-col>

                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>

                    <v-spacer></v-spacer>
                    <v-btn small @click="dialogD1 = false">Cancelar</v-btn>
                    <v-btn small :loading="loading" :disabled="loading" color="primary" @click="loader = 'loading'; loading=true; estadisticaConsultaD();">Consultar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-row>

    <v-row>

        <v-col cols="12" lg="12" style="padding-top:5px; padding-bottom:0px; margin-top:-40px;">

            <!-- TABLA 2 - RECUPERACION DIARIA -->
            <v-card v-if="selected==2 ">
                <v-card class="pa-2 green darken-4 white--text" style="margin-bottom:0px;">
                    <v-icon small class="white--text">list</v-icon>&nbsp;
                    LISTADO DE PEDIMENTOS EN RECUPERACIÓN DIARIA
                </v-card>

                <v-dialog v-model="dialogB2" max-width="600px">
                    <v-card>

                        <v-card-text>
                            <h5>Pedimentos Recuperación Diaria</h5>
                            <h5 class="caption gray--text font-weight-light">Seleccione el periodo</h5>
                            <v-container grid-list-md text-xs-center>
                                <v-form ref="form2" v-model="valid" lazy-validation>
                                    <v-row no-gutters dense>
                                        <v-col>
                                            <v-menu offset-x ref="menuB1" v-model="menuB1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field clearable v-on="on" v-model="fechaB_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="fechaB_de = parseDate(fechaB_de)" v-mask="'####-##-##'" :rules="[validaMes(fechaB_de, fechaB_a), validaFechas(fechaB_de, fechaB_a)]"></v-text-field>
                                                </template>

                                                <v-date-picker v-model="fechaB_de" color="secondary" scrollable locale="es-mx" @input="menuB1 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" x-small @click="menuB1 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col>
                                            <v-menu offset-x ref="menuB2" v-model="menuB2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field clearable v-on="on" v-model="fechaB_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="fechaB_a= parseDate(fechaB_a)" v-mask="'####-##-##'" :rules="[validaMes(fechaB_de, fechaB_a), validaFechas(fechaB_de, fechaB_a)]"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="fechaB_a" color="secondary" scrollable locale="es-mx" @input="menuB2 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" x-small @click="menuB2 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>

                                    </v-row>
                                </v-form>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>

                            <v-spacer></v-spacer>
                            <v-btn small @click="dialogB2 = false">Cancelar</v-btn>
                            <v-btn small :loading="loading" :disabled="loading || !valid" color="primary" @click="loader = 'loading'; loading=true; estadisticaTablaB();">Consultar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <div class="d-inline-flex text-right" style="position:absolute; z-index:1; matgin-top:60px; padding-right:40px;  width:100%">
                    <v-spacer />
                    <span class="overline primary--text font-weight-light "> PERIODO: {{fechaB_de}} - {{fechaB_a}}
                        <v-btn light icon title="Seleccionar Periodo" @click="dialogB2 = !dialogA2" v-tippy>
                            <v-icon small color="secondary">mdi-calendar</v-icon>
                        </v-btn>
                    </span>

                    <exportar-excel :data="data_tableB" :exportFields="data_tableB_excel" name="Recuperacion_Diaria.xlsx">
                        <v-btn light color="green" icon title="Descargar Información" v-tippy>
                            <v-icon dark>mdi-table</v-icon>
                        </v-btn>
                    </exportar-excel>
                </div>
                <v-client-table ref="vuetableB" :data="data_tableB" :columns="columns_tableB" :options="tableB_options" class="elevation-2 pa-2">
                    <template slot="noResults">
                        <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                    </template>
                    <template slot="search">
                        <v-alert icon="info" color="info">No se encontró ningún registro</v-alert>
                    </template>
                </v-client-table>

            </v-card>

            <!-- TABLA 3 - TEMPORALES -->
            <v-card v-if="selected==3">
                <v-card class="pa-2 secondary white--text" style="margin-bottom:0px;">
                    <v-icon small class="white--text">list</v-icon>&nbsp;
                    LISTADO DE PEDIMENTOS EN IMPORTACIONES TEMPORALES
                </v-card>

                <v-dialog v-model="dialogC2" max-width="600px">
                    <v-card>

                        <v-card-text>
                            <h5>Pedimentos Importaciones Temporales</h5>
                            <h5 class="caption gray--text font-weight-light">Seleccione el periodo</h5>
                            <v-container grid-list-md text-xs-center>
                                <v-form ref="form3" v-model="valid" lazy-validation>
                                    <v-row no-gutters dense>
                                        <v-col>
                                            <v-menu offset-x ref="menuC1" v-model="menuC1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field clearable v-on="on" v-model="fechaC_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="fechaC_de = parseDate(fechaC_de)" v-mask="'####-##-##'" :rules="[validaMes(fechaC_de, fechaC_a), validaFechas(fechaC_de, fechaC_a)]"></v-text-field>
                                                </template>

                                                <v-date-picker v-model="fechaC_de" color="secondary" scrollable locale="es-mx" @input="menuC1 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" x-small @click="menuA1 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col>
                                            <v-menu offset-x ref="menuC2" v-model="menuC2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field clearable v-on="on" v-model="fechaC_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="fechaC_a= parseDate(fechaC_a)" v-mask="'####-##-##'" :rules="[validaMes(fechaC_de, fechaC_a), validaFechas(fechaC_de, fechaC_a)]"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="fechaC_a" color="secondary" scrollable locale="es-mx" @input="menuC2 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" x-small @click="menuC2 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>

                                    </v-row>
                                </v-form>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>

                            <v-spacer></v-spacer>
                            <v-btn small @click="dialogC2 = false">Cancelar</v-btn>
                            <v-btn small :loading="loading" :disabled="loading || !valid" color="primary" @click="loader = 'loading'; loading=true; estadisticaTablaC(); estadisticaConsultaD()">Consultar</v-btn>

                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <div class="d-inline-flex text-right" style="position:absolute; z-index:1; matgin-top:60px; padding-right:40px;  width:100%">
                    <v-spacer />
                    <span class="overline primary--text font-weight-light "> {{fechaC_de}} - {{fechaC_a}}
                        <v-btn light icon title="Seleccionar Periodo" @click="dialogC2 = !dialogC2" v-tippy>
                            <v-icon small color="secondary">mdi-calendar</v-icon>
                        </v-btn>
                    </span>

                    <exportar-excel :data="data_tableC" :exportFields="data_tableC_excel" name="ImportacionesTemporales.xlsx">
                        <v-btn light color="green" icon title="Descargar Información" v-tippy>
                            <v-icon dark>mdi-table</v-icon>
                        </v-btn>
                    </exportar-excel>

                </div>
                <v-client-table ref="vuetableC" :data="data_tableC" :columns="columns_tableC" :options="tableC_options" class="elevation-2 pa-2">
                    <template slot="noResults">
                        <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                    </template>

                </v-client-table>

            </v-card>

            <!-- TABLA 4 - RETORNOS -->
            <v-card v-if="selected==4">

                <v-card class="pa-2 blue white--text" style="margin-bottom:0px;">
                    <v-icon small class="white--text">list</v-icon>&nbsp;
                    LISTADO DE OPERACIONES DE RETORNO
                </v-card>

                <v-dialog v-model="dialogD2" max-width="600px">
                    <v-card>

                        <v-card-text>
                            <h5>Operaciones de Retorno</h5>

                            <h5 class="caption gray--text font-weight-light">Seleccione el periodo</h5>
                            <v-container grid-list-md text-xs-center>
                                <v-form ref="form4" lazy-validation>
                                    <v-row no-gutters dense>
                                        <v-col>
                                            <v-menu offset-x ref="menuD1" v-model="menuD1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field clearable v-on="on" v-model="fechaD_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="fechaD_de = parseDate(fechaD_de)" v-mask="'####-##-##'" :rules="[ validaFechas(fechaD_de, fechaD_a)]">
                                                    </v-text-field>
                                                </template>

                                                <v-date-picker v-model="fechaD_de" color="secondary" scrollable locale="es-mx" @input="menuD1 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" x-small @click="menuD1 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col>
                                            <v-menu offset-x ref="menuD2" v-model="menuD2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field clearable v-on="on" v-model="fechaD_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="fechaD_a= parseDate(fechaD_a)" v-mask="'####-##-##'" :rules="[ validaFechas(fechaD_de, fechaD_a)]">
                                                    </v-text-field>
                                                </template>
                                                <v-date-picker v-model="fechaD_a" color="secondary" scrollable locale="es-mx" @input="menuD2 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" x-small @click="menuD2 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>

                                    </v-row>
                                </v-form>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>

                            <v-spacer></v-spacer>
                            <v-btn small @click="dialogD2 = false">Cancelar</v-btn>
                            <v-btn small :loading="loading" :disabled="loading || !valid" color="primary" @click="loader = 'loading'; loading=true; estadisticaTablaD();">Consultar</v-btn>

                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <div class="d-inline-flex text-right" style="position:absolute; z-index:1; matgin-top:60px; padding-right:40px;  width:100%">

                    <v-spacer />

                    <span class="overline primary--text font-weight-bold"> PERIODO: {{fechaD_de}} - {{fechaD_a}}
                        <v-btn light icon title="Seleccionar Periodo" @click="dialogD2 = !dialogD2" v-tippy>
                            <v-icon small color="secondary">mdi-calendar</v-icon>
                        </v-btn>
                    </span>

                    <exportar-excel :data="data_tableD" :exportFields="data_tableD_excel" name="OperacionesRetorno.xlsx">
                        <v-btn light color="green" icon title="Descargar Información" v-tippy>
                            <v-icon dark>mdi-table</v-icon>
                        </v-btn>
                    </exportar-excel>
                </div>
                <v-client-table ref="vuetableD" :data="data_tableD" :columns="columns_tableD" :options="tableD_options" class="elevation-2 pa-2">
                    <template slot="noResults">
                        <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                    </template>

                </v-client-table>

            </v-card>

        </v-col>

    </v-row>
    <v-row>

        <v-col cols="12" sm="6" :lg="6">

            <v-card style="min-height:800px;">
                <v-card class="pa-2 primary  white--text" style="margin-bottom:0px;">
                    <v-icon small class="white--text">list</v-icon>&nbsp;
                    LOG DE ACTIVIDAD RECIENTE EN PROCESOS SOLUCIONA24
                </v-card>
                <v-card-text>
                    <v-chip color="secondary"
                    outlined >PERIODO: {{periodo}}</v-chip>

                    <v-card style="top:-20px">
                        <v-card-title class="title font-weight-bold  primary--text">
                            CARGA WEB
                        </v-card-title>

                        <v-card-text>

                            <template>
                                <v-data-table dense :headers="headers" :items="indicadores.web" item-key="name" class="elevation-2 VueTables__table table table-striped table-bordered table-hover" hide-default-footer>
                                    <template slot="no-data">
                                        No se encontraron registros.
                                    </template>
                                </v-data-table>

                            </template>
                        </v-card-text>
                    </v-card>
                    <v-card style="top:-70px">
                        <v-card-title class="title font-weight-bold  primary--text">
                            CARGA SFTP
                        </v-card-title>

                        <v-card-text>

                            <template>
                                <v-data-table dense :headers="headersFTP" :items="indicadores.sftp" item-key="name" class="elevation-2 VueTables__table table table-striped table-bordered table-hover" hide-default-footer>
                                    <template slot="no-data">
                                        No se encontraron registros.
                                    </template>
                                </v-data-table>

                            </template>

                        </v-card-text>
                    </v-card>
                    <v-card style="top:-120px">
                        <v-card-title class="title font-weight-bold  primary--text">
                            RESUMEN DE LA CARGA
                        </v-card-title>

                        <v-card-text>

                            <template>
                                <v-data-table dense :headers="headersConteos" :items="indicadores.conteos" item-key="name" class="elevation-2 VueTables__table table table-striped table-bordered table-hover" hide-default-footer>
                            <template slot="no-data">
                                No se encontraron registros.
                            </template>
                            <template v-slot:item.tipo="{item}" >


                                    <span class="small-text blue--text" v-if="item.subtipo != '' ">
                                        &nbsp;&nbsp;&nbsp;&nbsp; -{{ item.subtipo }}
                                    </span>
                                    <span  v-if="item.subtipo == ''">
                                          {{ item.tipo }}
                                    </span>
                                </template>

                        </v-data-table>

                            </template>

                        </v-card-text>
                    </v-card>




                </v-card-text>
            </v-card>
        </v-col>

        <v-col cols="12" sm="6" :lg="6">

            <v-card style="min-height:800px;">
                <v-card class="pa-2 purple darken-3 white--text" style="margin-bottom:0px; ">
                    <v-icon small class="white--text">list</v-icon>&nbsp;
                    LOG DE ACCESO DE USUARIOS
                </v-card>

                <v-card>
                    <v-card-title class="title font-weight-bold  primary--text">
                     USUARIOS DE LA EMPRESA
                    </v-card-title>

                    <v-card-text>

                        <template>
                            <v-data-table dense :headers="headersUser" :items="indicadores.acceso_usuarios" item-key="name" class="elevation-2 VueTables__table table table-striped table-bordered table-hover" hide-default-footer>
                                <template slot="no-data">
                                    No se encontraron registros.
                                </template>
                            </v-data-table>

                        </template>

                    </v-card-text>
                </v-card>
                <v-card >
                    <v-card-title class="title font-weight-bold  primary--text">
                         USUARIOS DE RECE
                    </v-card-title>

                    <v-card-text>

                        <template>
                            <v-data-table dense :headers="headersUser" :items="indicadores.acceso_autoridad" item-key="name" class="elevation-2 VueTables__table table table-striped table-bordered table-hover" hide-default-footer>
                                <template slot="no-data">
                                    No se encontraron registros.
                                </template>

                            </v-data-table>

                        </template>

                    </v-card-text>
                </v-card>

            </v-card>

        </v-col>

    </v-row>

    <div id="el" style="height: 200px;"></div>

</v-container>
</template>

<script>
var colors_bars = [
    "#eb7601", //naranja
    "#ffde17", //amarillo
    "#006594", //azul
    "#56baec", // azul cielo
    "#ffffff" // azul cielo
];
import axios from "axios";
import moment from "moment";
//import Canvg from 'canvg';
import jsPDF from 'jspdf';
//import html2canvas from 'html2canvas';

//window.html2canvas = html2canvas

export default {
    name: "DashboardDashboard",
    watch: {
        coneliminados() {
            if (this.$local_storage.get("perfil_grupo") != 43) {
                this.estadisticaTablaD();
                this.estadisticaConsultaD();
            }

        }
    },
    data() {
        return {

            headers: [{
                    text: 'TIPO',
                    align: 'start',
                    sortable: false,
                    value: 'tipo_archivo',
                },
                {
                    text: 'NOMBRE DEL ARCHIVO',
                    value: 'archivo'
                },
                {
                    text: 'FECHA',
                    value: 'fecha'
                },
                {
                    text: 'USUARIO',
                    value: 'usuario'
                },
                {
                    text: 'ESTATUS',
                    value: 'estatus'
                },
                {
                    text: 'ERROR',
                    value: 'error'
                },
            ],
            headersConteos: [{
                    text: 'TIPO',
                    align: 'start',
                    sortable: false,
                    value: 'tipo',
                },
                {
                    text: 'TOTAL PEDIMENTOS',
                    align: 'center',
                    value: 'pedimentos'
                },
                {
                    text: 'TOTAL DE REGISTROS',
                    align: 'center',
                    value: 'registros'
                },

            ],
            headersUser: [{
                    text: 'USUARIO',
                    value: 'usuario'
                },
                {
                    text: 'FECHA',
                    value: 'fecha'
                },

            ],
            headersFTP: [{
                    text: 'TIPO',
                    align: 'start',
                    sortable: false,
                    value: 'tipo_archivo',
                },
                {
                    text: 'NOMBRE DEL ARCHIVO',
                    value: 'archivo'
                },
                {
                    text: 'FECHA',
                    value: 'fecha'
                },
                {
                    text: 'ESTATUS',
                    value: 'estatus'
                },
                {
                    text: 'ERROR',
                    value: 'error'
                },
            ],
            ver: false,
            anio_recuperacion: "",
            indicadores: "",
            titulo_detalle: "",
            valid: true,
            loader: null,
            loading: false,
            pedimentosB: 0,
            remesasB: 0,
            consultaB: "",
            consultaC: {
                "impo": 0,
                "expo": 0
            },
            consultaD: "",
            coneliminados: false,
            consultaG1: "",
            consultaG2: "",
            consultaG3: "",

            tablaB: "",
            impoC: 0,
            expoC: 0,
            impoD: 0,
            expoD: 0,
            filtroB: "",
            correctos: 0,
            incorrectos: 0,
            selected: 1,
            fab: false,
            dialog1: false,
            dialog2: false,
            dialog3: false,
            menuB: false,
            menuC: false,
            menuD: false,
            dialogA1: false,
            dialogB1: false,
            dialogC1: false,
            dialogD1: false,
            dialogA2: false,
            dialogB2: false,
            dialogC2: false,
            dialogD2: false,
            menuA1: false,
            menuA2: false,
            menuB1: false,
            menuB2: false,
            menuC1: false,
            menuC2: false,
            menuD1: false,
            menuD2: false,
            fechaA_de: "",
            fechaA_a: "",
            fechaB_de: "",
            fechaB_a: "",
            fechaC_de: "",
            fechaC_a: "",
            fechaD_de: "",
            fechaD_a: "",
            mesB: "",
            mesC: "",
            mesD: "",
            mes1: "",
            mes2: "",
            mes3: "",
            a1: "",
            a2: "",
            a3: "",

            //////////////////

            //TABLA CONSULTA DIARIA
            data_tableB: [],
            columns_tableB: [
                "NoPedimento",
                "FechaPagoReal",
                "TipoOperacion",
                "ClaveDocumento",
                "TipoDocumento",
                "TipoCambio",
                "ValorComercial",
                "PesoBruto",
                "CuentaRemesas"
            ],
            tableB_options: {
                filterable: true,
                filterByColumn: false,
                texts: {
                    filter: '',
                    filterPlaceholder: 'Buscar',
                },
                orderBy: {
                    column: 'FechaPagoReal',
                    ascending: false
                },
                headings: {
                    "NoPedimento": "No. de Pedimento",
                    "FechaPagoReal": "Fecha Pago Real",
                    "TipoOperacion": "Tipo Operación",
                    "ClaveDocumento": "Clave Documento",
                    "TipoDocumento": "Tipo Documento",
                    "TipoCambio": "Tipo Cambio",
                    "ValorComercial": "Valor Comercial",
                    "PesoBruto": "Peso Bruto",
                    "CuentaRemesas": "Cuenta Remesas",
                }
            },
            data_tableB_excel: {

                "No. de Pedimento": "NoPedimento",
                "Fecha Pago Real": "FechaPagoReal",
                "Tipo Operación": "TipoOperacion",
                "Clave Documento": "ClaveDocumento",
                "Tipo Documento": "TipoDocumento",
                "Tipo Cambio": "TipoCambio",
                "Valor Comercial": "ValorComercial",
                "Peso Bruto": "PesoBruto",
                "Cuenta Remesas": "CuentaRemesas",
                "Medio Transporte": "MedioTransporte",
                "No. Operación": "NoOperacion"
            },

            //TABLA REVISION
            data_tableC: [],
            columns_tableC: [
                "NoPedimento",
                "FechaPagoReal",
                "TipoOperacion",
                "ClaveDocumento",
                "TipoDocumento",
                "TipoCambio",
                "ValorComercial",
                "PesoBruto",
                "CuentaRemesas"

            ],
            tableC_options: {
                filterable: true,
                filterByColumn: false,
                texts: {
                    filter: '',
                    filterPlaceholder: 'Buscar',
                },
                orderBy: {
                    column: 'FechaPagoReal',
                    ascending: false
                },
                headings: {
                    "NoPedimento": "No. de Pedimento",
                    "FechaPagoReal": "Fecha Pago Real",
                    "TipoOperacion": "Tipo Operación",
                    "ClaveDocumento": "Clave Documento",
                    "TipoDocumento": "Tipo Documento",
                    "TipoCambio": "Tipo Cambio",
                    "ValorComercial": "Valor Comercial",
                    "PesoBruto": "Peso Bruto",
                    "CuentaRemesas": "Cuenta Remesas",
                }
            },
            data_tableC_excel: {
                "No. de Pedimento": "NoPedimento",
                "Fecha Pago Real": "FechaPagoReal",
                "Tipo Operación": "TipoOperacion",
                "Clave Documento": "ClaveDocumento",
                "Tipo Documento": "TipoDocumento",
                "Tipo Cambio": "TipoCambio",
                "Valor Comercial": "ValorComercial",
                "Peso Bruto": "PesoBruto",
                "Cuenta Remesas": "CuentaRemesas",
                "Medio Transporte": "MedioTransporte",
                "No. Operación": "NoOperacion"

            },

            //TABLA REVISION
            data_tableD: [],
            columns_tableD: [
                "NoPedimento",
                "FechaPagoReal",
                "TipoOperacion",
                "ClaveDocumento",
                "TipoDocumento",
                "TipoCambio",
                "ValorComercial",
                "PesoBruto",
                "CuentaRemesas"

            ],
            tableD_options: {
                filterable: true,
                filterByColumn: false,
                texts: {
                    filter: '',
                    filterPlaceholder: 'Buscar',
                },
                orderBy: {
                    column: 'FechaPagoReal',
                    ascending: false
                },
                headings: {
                    "NoPedimento": "No. de Pedimento",
                    "FechaPagoReal": "Fecha Pago Real",
                    "TipoOperacion": "Tipo Operación",
                    "ClaveDocumento": "Clave Documento",
                    "TipoDocumento": "Tipo Documento",
                    "TipoCambio": "Tipo Cambio",
                    "ValorComercial": "Valor Comercial",
                    "PesoBruto": "Peso Bruto",
                    "CuentaRemesas": "Cuenta Remesas",
                }
            },
            data_tableD_excel: {
                "No. de Pedimento": "NoPedimento",
                "Fecha Pago Real": "FechaPagoReal",
                "Tipo Operación": "TipoOperacion",
                "Clave Documento": "ClaveDocumento",
                "Tipo Documento": "TipoDocumento",
                "Tipo Cambio": "TipoCambio",
                "Valor Comercial": "ValorComercial",
                "Peso Bruto": "PesoBruto",
                "Cuenta Remesas": "CuentaRemesas",
                "Medio Transporte": "MedioTransporte",
                "No. Operación": "NoOperacion"
            },
        };
    },

    computed: {
        soloSoluciona() {
            return this.$local_storage.get("DATA.STAGE.bitacora") != 100 && this.$local_storage.get("VUCEM.Transmision.nuevo.cove") != 100 &&
                this.$local_storage.get("Reportes.ecosting.consulta.facturas") != 100 && this.$local_storage.get("EmanifiestoCP.bitacora") != 100 &&
                this.$local_storage.get("EmanifiestoAA.edrive.consultar") != 100 &&
                (this.$local_storage.get("EmanifiestoMV.bitacora") != 100) && this.$local_storage.get("Logistica.nuevoregistro") != 100 &&
                (this.$local_storage.get("Modulo15") == 100 || this.$local_storage.get("Modulo16") == 100);
        },
        expediente() {
            return (

                this.$local_storage.get(
                    "BANDEJA.DE.CORREO"
                ) == 100 && false
            );
        },
        is_consignatario() {
            return this.$local_storage.get("subtipo_usuario") == "embarcadores_consignatarios";
        },
        anios() {
            var f = new Date();
            let a = [];
            let y = f.getFullYear();
            let i = 1;
            for (i; i < 15; i++) {
                a.push(y)
                y = y - 1;
            }
            return a;
        },

        soloEmanifiesto() {
            return this.$local_storage.get("DATA.STAGE.bitacora") != 100 && this.$local_storage.get("VUCEM.Transmision.nuevo.cove") != 100 &&
                this.$local_storage.get("Reportes.ecosting.consulta.facturas") != 100 && this.$local_storage.get("Emanifiesto.bitacora") == 100;
        },
        periodo(){
            let result = "";
            if(this.indicadores.periodo != undefined)
                result = this.indicadores.periodo.substring(0, 11) + " a " + this.indicadores.periodo.substring(22, 33) ;
            return " de " + result  ;
        }
    },
    mounted() {
        this.ver = this.$local_storage.get('sa24.datastage.carga') == 100;
    },
    async created() {

        if (this.$local_storage.get("es_transportista") == 1)
            this.$router.replace("/indext").catch(() => {});

        if (this.$local_storage.get("es_agente") == 1)
            this.$router.replace("/indexAA").catch(() => {});

        if (this.$local_storage.get("soloCartaPorte") == 100)
            this.$router.replace("/indext").catch(() => {});

        if (this.$local_storage.get("Modulo14") == 100 && this.$local_storage.get("id_cliente") > 0)
            this.$router.replace("/indexAAC").catch(() => {});

        if (this.$store.state.emanifiesto == true)
            this.$router.replace("/manifestacion/transmitir").catch(() => {});

        if (this.$store.state.costing == true)
            this.$router.replace("/facturastransito").catch(() => {});

        if (this.$store.state.trafico == true)
            this.$router.replace("/trafico_index").catch(() => {});

        if (this.$store.state.sa31 == true || this.$local_storage.get("soloSA31") == 100)
            this.$router.replace("/indexsa31").catch(() => {});

        if (this.$local_storage.get("perfil_grupo") == 43) {
            this.$router.replace("/trafico/reporte_embarques").catch(() => {});
        } else if (this.$local_storage.get("tipo_usuario") == "Super Usuario" && ["0", 0].includes(this.$local_storage.get("id_cliente"))) {
            this.$router.replace("/listaclientes").catch(() => {});
        } else {
            if (this.$local_storage.get("VUCEM.Pedimento.consulta.pedimento") != 100 && this.$local_storage.get("VUCEM.Pedimento.consulta.cove") != 100) {
                if (this.$local_storage.get("DATA.STAGE.cargazip") == 100)
                    this.$router.replace("/datastage/bitacorazip").catch(() => {});
                else if (this.$local_storage.get("VUCEM.Transmision.ver.coves") == 100)
                    this.$router.replace("/transmision/covedetalles").catch(() => {});
                else if (this.$local_storage.get("VUCEM.Pedimento.consulta.pedimento") == 100)
                    this.$router.replace("/reportes/consultar_pedimentos_ws").catch(() => {});

            } else {
                var f_de = new Date();
                var f_a = new Date();

                f_de.setDate(f_de.getDate() - 7);

                let y = f_a.getFullYear();
                let m = f_a.getMonth() + 1;
                let d = f_a.getDate();

                let y_de = f_de.getFullYear();
                let m_de = f_de.getMonth() + 1;
                let d_de = f_de.getDate();

                this.a1 = y;
                this.a2 = y;
                this.a3 = y;
                if (m < 10)
                    m = '0' + m;
                if (m_de < 10)
                    m_de = '0' + m_de;
                if (d < 10)
                    d = '0' + d;
                if (d_de < 10)
                    d_de = '0' + d_de;
                this.mesB = y + "-" + m;
                this.mesC = y + "-" + m;
                this.mesD = y + "-" + m;

                let fecha_a = y + "-" + m + "-" + d;
                let fecha_de = y_de + "-" + m_de + "-" + d_de;
                this.fechaA_a = fecha_a;
                this.fechaA_de = y_de + "-" + m_de + "-01";
                this.fechaB_a =  y_de + "-" + m_de + "-01";
                this.fechaB_de = fecha_de;
                this.fechaC_a = fecha_a;
                this.fechaC_de = y_de + "-" + m_de + "-01";
                this.fechaD_a = fecha_a;
                this.fechaD_de = y_de + "-" + m_de + "-01";
                this.selected = 1;

                this.getAnioRecuperacion();
                this.estadisticaTablaB();
                this.estadisticaConsultaB();
                this.estadisticaConsultaC();
                this.estadisticaConsultaD();
                this.consultaIndicadores();

            }

        }

    },
    methods: {
        openDialog() {

            this.dialogA2 = true;

        },
        filterResult() {
            Event.$emit('vue-tables.filter::filtro', this.filtro);
        },
        complete(index) {
            this.list[index] = !this.list[index];
        },
        getAnioRecuperacion: function () {
            let id_cliente = this.$local_storage.get("id_cliente", 0);
            if (id_cliente > 0) {
                axios.get(this.$hostname + "clientes/" + id_cliente + "/")
                    .then(response => {
                        if (response.data != null && response.data.anio_recuperacion != null)
                            this.anio_recuperacion = response.data.anio_recuperacion;
                        else
                            this.anio_recuperacion = "";
                    })
                    .catch(error => {});
            }

        },

        async estadisticaConsultaB() {

            let m = this.mesB.split("-");
            var datos = {
                "rfc": this.$local_storage.get("rfc"),
                "tipo": 1,
                "anio": m[0],
                "mes": m[1]
            }

            await axios.post(this.$apiReportes + 'reportes/estadisticas/', datos)
                .then((response) => {
                    this.consultaB = response.data;
                    this.remesasB = parseInt(this.consultaB.remesas) + parseInt(this.consultaB.remesas_desaduanados);
                    this.pedimentosB = parseInt(this.consultaB.pedimentos) + parseInt(this.consultaB.pedimentos_desaduanados);

                })
                .catch((error) => {
                    this.consultaB = {
                        "pedimentos": 0,
                        "remesas": 0,
                        "pedimentos_desaduanados": 0,
                        "remesas_desaduanados": 0
                    };
                    this.remesasB = 0;
                    this.pedimentosB = 0;

                }).then(() => {
                    this.dialogB1 = false;
                    this.loader = null;
                    this.loading = false;
                });
        },
        async estadisticaConsultaC() {

            let m = this.mesC.split("-");
            this.impoC = 0;
            this.expoC = 0;
            var datos = {
                "rfc": this.$local_storage.get("rfc"),
                "tipo": 8,
                "anio": m[0],
                "mes": m[1],
            }

            await axios.post(this.$apiReportes + 'reportes/estadisticas/', datos)
                .then((response) => {


                        this.consultaC = response.data;
                        this.impoC = parseInt(this.consultaC.pedimentos) + parseInt(this.consultaC.pedimentos_desaduanados);
                        this.expoC = parseInt(this.consultaC.remesas) + parseInt(this.consultaC.remesas_desaduanados);

                        this.consultaC = {
                            "impo": this.impoC,
                            "expo":  this.expoC,
                        };


                })
                .catch((error) => {
                    this.consultaC = {
                        "impo": 0,
                        "expo": 0,
                    };
                    this.impoC = 0;
                    this.expoC = 0;

                }).then(() => {
                    this.dialogC1 = false;
                    this.loader = null;
                    this.loading = false;
                });
        },
        async estadisticaConsultaD() {
            let m = this.mesD.split("-");
            var datos = {
                "rfc": this.$local_storage.get("rfc"),
                "tipo": 10,
                "anio": m[0],
                "mes": m[1],
            }

            await axios.post(this.$apiReportes + 'reportes/estadisticas/', datos)
                .then((response) => {

                        this.consultaD = response.data;
                        this.impoD = parseInt( this.consultaD.pedimentos) + parseInt(this.consultaD.pedimentos_desaduanados);
                        this.expoD = parseInt( this.consultaD.remesas) + parseInt(this.consultaD.remesas_desaduanados);
                        this.consultaD = {
                            "impo": this.impoD,
                            "expo":  this.expoD,
                        };

                })
                .catch((error) => {
                    this.consultaD = {
                        "impo": 0,
                        "expo": 0,
                    };
                    this.impoD = 0;
                    this.expoD = 0;
                }).then(() => {
                    this.dialogD1 = false;
                    this.loader = null;
                    this.loading = false;
                });
        },

        estadisticaTablaB() {
            let self = this;
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                "rfc": this.$local_storage.get("rfc"),
                "tipo": 2,
                "fecha_de": this.fechaB_de,
                "fecha_a": this.fechaB_a,
            }

            axios.post(this.$apiReportes + 'reportes/estadisticas/', datos)
                .then((response) => {

                    self.data_tableB = response.data;
                    self.data_tableB.forEach(element => {
                        let a = element.FechaPagoReal.split('-')
                        element.FechaPagoReal = a[2] + '-' + a[1] + '-' + a[0];
                    });
                })
                .catch((error) => {
                    console.log(error);
                    this.data_tableB = [];
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                    this.dialogB2 = false;
                    this.loader = null;
                    this.loading = false;
                });

        },
        estadisticaTablaC() {
            let self = this;
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                "rfc": this.$local_storage.get("rfc"),
                "tipo": 9,
                "fecha_de": this.fechaC_de,
                "fecha_a": this.fechaC_a,

            }

            axios.post(this.$apiReportes + 'reportes/estadisticas/', datos)
                .then((response) => {
                    this.data_tableC = response.data;
                    self.data_tableC.forEach(element => {
                        let a = element.FechaPagoReal.split('-')
                        element.FechaPagoReal = a[2] + '-' + a[1] + '-' + a[0];
                    });
                })
                .catch((error) => {
                    console.log(error);
                    this.data_tableC = [];
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                    this.dialogC2 = false;
                    this.loader = null;
                    this.loading = false;
                });

        },
        estadisticaTablaD() {
            let self = this;
            let alertas = [];

            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                "rfc": this.$local_storage.get("rfc"),
                "tipo": 11,
                "fecha_de": this.fechaD_de,
                "fecha_a": this.fechaD_a,
            }

            axios.post(this.$apiReportes + 'reportes/estadisticas/', datos)
                .then((response) => {
                    this.data_tableD = response.data;
                    self.data_tableD.forEach(element => {
                        let a = element.FechaPagoReal.split('-')
                        element.FechaPagoReal = a[2] + '-' + a[1] + '-' + a[0];
                    });
                })
                .catch((error) => {
                    this.data_tableD = [];
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                    this.dialogD2 = false;
                    this.loader = null;
                    this.loading = false;
                });

        },

        selectItem(index) {
            if(this.selected == index)
                this.selected = 1;
            else
                this.selected = index;

            if (index == 2) {
                this.estadisticaTablaB();
            }
            if (index == 3) {
                this.estadisticaTablaC();
            }
            if (index == 4) {
                this.estadisticaTablaD();
            }
        },
        cambiarMesB() {
            this.dialogB1 = true;
        },
        cambiarMesC() {
            this.dialogC1 = true;
        },
        cambiarMesD() {
            this.dialogD1 = true;
        },
        formatNumber: function (x) {
            if (x == undefined) return 0;
            x = x.toString();
            var pattern = /(-?\d+)(\d{3})/;
            while (pattern.test(x)) x = x.replace(pattern, "$1,$2");
            return x;
        },
        validaFechas: function (FD, FA) {
            if (FD == null)
                FD = ""
            if (FA == null)
                FA = ""

            if (FD != "" && FD == "") {
                return "Debe seleccionar las dos fechas o ninguna.";
            } else if (FD == "" && FA != "") {
                return "Debe seleccionar las dos fechas o ninguna.";
            }
            return true;
        },
        validaMes: function (FD, FA) {
            if (FD != "" && FA != "") {
                var inicio = moment(FD, "YYYY-MM-DD");
                var fin = moment(FA, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, 'days')
                if (diferencia < 0)
                    return "La Fecha Final no debe ser menor a la Fecha Inicial.";
                if (Math.abs(diferencia) > 31)
                    return "Periodo máximo de consulta 31 días. Favor de verificar.";
            }
            return true;
        },
        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        async consultaIndicadores() {

            var datos = {
                "rfc": this.$local_storage.get("rfc"),
            }
            await axios.post('https://apisoluciona.econnectpro.mx/soluciona24/get_actividad_reciente/', datos)
                .then((response) => {

                    this.indicadores = response.data;

                })
                .catch((error) => {

                }).then(() => {

                });
        },

    }
};
</script>

<style scoped>
.footer-hide>>>.VuePagination {
    display: none;
}
.v-data-table >>> .v-data-table__wrapper > table > tbody > tr > th,
.v-data-table >>> .v-data-table__wrapper > table > thead > tr > th,
.v-data-table >>> .v-data-table__wrapper > table > tfoot > tr > th {
   font-size: 12px !important;
   color: gray
}
</style>
